import classNames from 'clsx';

import './styles.css';

type ModuleHeaderProps = {
  className?: string;
  children?: React.ReactNode;
};

export function ModuleHeader({ className, children, ...props }: ModuleHeaderProps) {
  return (
    <div {...props} className={classNames('Module-header', className)}>
      {children}
    </div>
  );
}
